const breadCrumb = "Lotação de Servidores - Manutenção do Servidor";
const parentRoute = "/cadastro-de-servidor";

const routes = [
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor",
    name: "cadastro-de-habilidades-do-servidor",
    meta: {
      allowedPermissions: ["habilidades_list"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilidades do Servidor",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor/novo",
    name: "cadastro-de-habilidades-do-servidor-novo",
    meta: {
      allowedPermissions: ["habilidades_insert"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilidades do Servidor - Novo",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor/editar/:id",
    name: "cadastro-de-habilidades-do-servidor-editar",
    meta: {
      allowedPermissions: ["habilidades_update"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilidades do Servidor - Editar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilidades-do-servidor/visualizar/:id",
    name: "cadastro-de-habilidades-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["habilidades_show"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilidades do Servidor - Visualizar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilidadesDoServidor/CadastroDeHabilidadesDoServidorShow.vue"
      ),
  },
];

export default routes;
